import type {OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum} from '@stripe-internal/data-v1/schema/types';
import {message, type MessageDescriptor} from '@sail/intl';

export type TokenSelectCurrency =
  OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum;

type TokenInfo = {
  processingTimeMessage: MessageDescriptor;
};

const messages = {
  btcProcessingTime: message({
    id: 'crypto.payins.v2.token_select.btc_processing_time',
    description: 'Processing time for BTC transactions',
    defaultMessage: '20–30 mins',
  }),

  ethProcessingTime: message({
    id: 'crypto.payins.v2.token_select.eth_processing_time',
    description: 'Processing time for ETH transactions',
    defaultMessage: '1–5 mins',
  }),

  fastProcessingTime: message({
    id: 'crypto.payins.v2.token_select.fast_processing_time',
    description: 'Processing time for fast transactions (SOL, USDC)',
    defaultMessage: '<30 secs',
  }),
};

// The key order here controls the display order in the token select screen.
export const TOKEN_INFO_MAP: Record<TokenSelectCurrency, TokenInfo> = {
  btc: {
    processingTimeMessage: messages.btcProcessingTime,
  },
  cash: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  eth: {
    processingTimeMessage: messages.ethProcessingTime,
  },
  sol: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  usdc: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  usdg: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  usdp: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  phantom_cash: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  usdsui: {
    processingTimeMessage: messages.fastProcessingTime,
  },
  usdt: {
    processingTimeMessage: messages.ethProcessingTime,
  },
};

export const isAnyCryptoToken = (
  selectedToken: string | null,
): selectedToken is OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum =>
  selectedToken !== null && selectedToken in TOKEN_INFO_MAP;
